import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { PaginationHelpers as Page } from '../../../../../helpers';
import {
    getMyJobApplications,
    updateApplicationToComplete,
    getApplicationStatus,
} from '../../../../../actions/jobs/jobs';
import { JobApplicationsEmpty } from './elements/JobApplicationsEmpty'
import { JobApplicationsInternal } from './elements/JobApplicationsInternal'
import { JobApplicationsExternal } from './elements/JobApplicationsExternal'
import { Pagination } from '../../../../common/elements';
import Loader from "../../../../common/elements/Loader";

class JobApplicationsPage extends Component {

    componentWillMount() {
        const { location, options, getMyJobApplications, getApplicationStatus } = this.props;
        const person_id = localStorage.getItem('person_id'),
            page = location.query.page,
            jobId = location.query.id;
        getApplicationStatus();
        getMyJobApplications(options, page ? page : 1, person_id, jobId);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.query.page !== nextProps.location.query.page) {
            nextProps.location.query.page === 'undefined' ? this.getNextJobs(1) : this.getNextJobs(nextProps.location.query.page);
        }
    }

    deleteApplication = (jobId) => {
        const { updateApplicationToComplete, getMyJobApplications, location, options } = this.props,
            person_id = localStorage.getItem('person_id'),
            page = location.query.page;
        updateApplicationToComplete(person_id, 2, jobId);
        getMyJobApplications(options, page ? page : 1, person_id);
    };

    getNextJobs(pageId) {
        const { getMyJobApplications, options } = this.props,
            person_id = localStorage.getItem('person_id');
        getMyJobApplications(options, pageId, person_id);
        browserHistory.push(`/my-jobs-section/my-applications?page=${pageId}#topoflist`);
    }

    render() {
        const {
            applications,
            paging,
            location,
            statuses
        } = this.props,
            { internal, external } = applications,
            pageLocation = location.query.page;

        if (!paging || (statuses && !statuses.length)) {
            return <Loader />
        }

        const totalPages = paging.total_pages,
            currentPage = Page.setCurrentPage(pageLocation, totalPages),
            pagination_details = Page.getCurrentPage(currentPage, totalPages),
            pageNumbers = Page.getPageNumbers(pagination_details);

        return (
            <div className="main__content">
                <h1 className="h1">My Applications</h1>
                {
                    !internal.length && !external.length && <JobApplicationsEmpty />
                }

                {
                    internal && internal.length > 0 &&
                    <JobApplicationsInternal
                        deleteApplication={this.deleteApplication}
                        statuses={statuses}
                        internal={internal}
                    />
                }

                {
                    external && external.length > 0 &&
                    <JobApplicationsExternal
                        external={external}
                    />
                }

                {
                    totalPages > 1 ? (
                        <Pagination
                            currentPage={currentPage}
                            pagination={pagination_details}
                            pageNumbers={pageNumbers}
                            totalPages={totalPages}
                            onPaginationClick={(currentPage) => this.getNextJobs(currentPage)}
                        />
                    ) : ''
                }
            </div>
        );
    }
}

JobApplicationsPage.propTypes = {
    getMyJobApplications: PropTypes.func,
    updateApplicationToComplete: PropTypes.func,
    getApplicationStatus: PropTypes.func,
    options: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    paging: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    statuses: PropTypes.array,
    applications: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
        applications: state.jobs.applications,
        options: state.jobs.options,
        paging: state.jobs.pagination,
        statuses: state.jobs.statuses,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMyJobApplications: (options, page, person_id, jobId) => dispatch(getMyJobApplications(options, page, person_id, jobId)),
        updateApplicationToComplete: (personId, applied, jobId) => dispatch(updateApplicationToComplete(personId, applied, jobId)),
        getApplicationStatus: () => dispatch(getApplicationStatus()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobApplicationsPage);


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobApplicationsPage.js